<template>
	<div>
		<modalDetail :dialog="dialog" :detailEmailLog="detailEmailLog" @hideDialog="() => { dialog = false }"></modalDetail>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col cols="12" class="px-4 pb-1">
					<v-row>
						<v-col cols="12" md="4">
							<v-menu v-model="emailLogMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="convertDate(datetime)" label="Tanggal" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
								</template>
								<v-date-picker locale="id" range color="primary" v-model="datetime"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Pengirim" v-model="emailLogFrom.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Tujuan" v-model="emailLogTo.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Judul" v-model="emailLogSubject.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Respon" v-model="emailLogResponse.value"></v-text-field>
						</v-col>
					</v-row>
				</v-col>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
					<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
				</v-card-actions>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="emailLogData" :search="search" hide-default-footer :options.sync="option" :server-items-length="emailLogPagination.total_data" class="table-w-140">
				<template v-slot:item.email_log_datetime="{ item }">
					<div class="">{{ item.email_log_datetime | tanggaljam }}</div>
				</template>
				<template v-slot:item.email_log_from="{ item }">
					<div class="">{{ item.email_log_from }}</div>
				</template>
				<template v-slot:item.email_log_to="{ item }">
					<div class="">{{ item.email_log_to }}</div>
				</template>
				<template v-slot:item.email_log_subject="{ item }">
					<div class="">{{ item.email_log_subject }}</div>
				</template>
				<template v-slot:item.email_log_content="{ item }">
					<div class="">{{ item.email_log_content }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="getDetail(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-text-box-search</v-icon>
							</v-btn>
						</template>
						<span>Detail</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div> </div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!emailLogPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="emailLogPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="emailLogPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalDetail from '@/views/MLwarehouse/emailLog/EmailLogDetail'

export default {
	inject: ['theme'],
	components: {
		modalDetail
	},
	data() {
		return {
			detailEmailLog: {},
			messages: '',
			propDelete: '',
			page: 1,
			sortBy: 'email_log_datetime',
			sortDir: 'DESC',
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			paramProp: '',
			paramDelid: '',
			paramDelName: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			responseDatetime: false,
			emailLogMenu: false,
			datetime: [],
			search: '',
			headers: [
			{ text: 'Aksi', value: 'action', sortable: false, },
			{ text: 'Tanggal', value: 'email_log_datetime', sortable: true, },
			{ text: 'Pengirim', value: 'email_log_from', sortable: true, },
			{ text: 'Tujuan', value: 'email_log_to', sortable: true, },
			{ text: 'Judul', value: 'email_log_subject', sortable: false, },
			{ text: 'Respon', value: 'email_log_response', sortable: false, },
			],
			emailLogDatetime: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'email_log_datetime'
			},
			emailLogFrom: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'email_log_from'
			},
			emailLogTo: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'email_log_to'
			},
			emailLogSubject: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'email_log_subject'
			},
			emailLogResponse: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'email_log_response'
			},
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState('emailLog', ['emailLogData', 'emailLogPagination']),
	},
	methods: {
		...mapActions('emailLog', ['getEmailLog', 'setDetailEmailLog']),
		...mapMutations('emailLog', ['clearDataEmailLog']),

		getData() {
			this.getEmailLog(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		getDetail(item) {
			this.setDetailEmailLog(item).then(()=> {
				this.detailEmailLog = item
				this.dialog = true
			})
		},
		cari() {
			this.params= []

			if (this.emailLogDatetime.value) {
				if (this.emailLogDatetime.value.length > 1) {
					this.emailLogDatetime.value.sort()
					let date = this.emailLogDatetime.value.join('::')
					this.emailLogDatetime.value = date
				}
				this.params.push(Object.assign({}, this.emailLogDatetime))
			}

			if(this.emailLogFrom.value)
				this.params.push(this.emailLogFrom)

			if(this.emailLogTo.value)
				this.params.push(this.emailLogTo)

			if(this.emailLogSubject.value)
				this.params.push(this.emailLogSubject)

			if(this.emailLogResponse.value)
				this.params.push(this.emailLogResponse)

			this.page = 1
			this.getData()
		},
		resetFilter() {
			this.datetime = []
			this.emailLogFrom.value = ''
			this.emailLogTo.value = ''
			this.emailLogSubject.value = ''
			this.emailLogResponse.value = ''
			this.params = []
			this.limit = 10
			this.getData()
		},
	},
	created() {
		this.getData()
		this.$store.dispatch('setPageTitle', `Log Email`);
	},
	beforeDestroy(){
		this.clearDataEmailLog()
	},
	watch: {
		datetime(val) {
			this.emailLogDatetime.value = val
		},
		page() {
			this.getData()
		},
		limit() {
			this.page = 1
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>